import clsx from "clsx";
import React, { FunctionComponent } from "react";

import { partTypeWheel } from "../../../../constants/partTypes";
import { useLanguage } from "../../../../i18n/useLanguage";
import { WheelPartItem } from "../../../../queries/useSearchWheelsByVehicle";
import { useIsLoggedOn } from "../../../../stores/hooks/useIsLoggedOn";
import { Image } from "../../../../ui/Image/Image";
import { fixTireImageUrl } from "../../../../util/fixTireImageUrl";
import { getPartFallbackSrc } from "../../../../util/getPartFallbackSrc";
import { getPartName } from "../../../../util/getPartName";
import { useStockIsEnabled } from "../../../Cart/useStockIsEnabled";
import { WheelStock, filterStock } from "../../../Wheels/Results/WheelStock";
import { PartPrice } from "./PartPrice";

export const ComboTileWheel: FunctionComponent<{
  onClick?: VoidFunction;
  part: WheelPartItem;
  quantity: number;
}> = ({ onClick, part, quantity }) => {
  const [language] = useLanguage();
  const isLoggedOn = useIsLoggedOn();
  const stockIsEnabled = useStockIsEnabled();

  const allStock = part?.partStock.primaryPart.filter(({ stockQty }) => {
    const hasQty = Number(stockQty) > 0;
    return hasQty;
  });

  const shouldRenderStockData = Boolean(stockIsEnabled && allStock?.length);

  const dlrStock = filterStock(allStock || [], "DLR");
  const rltStock = filterStock(allStock || [], "RLT");

  return (
    <div
      className={clsx("combo__tile md:combo__tile--md lg:combo__tile--lg")}
      id={`combo-${part.partDetails.primaryPart.itemId}`}
      onClick={onClick}
    >
      <h3>{getPartName(part, language)}</h3>
      <div className="combo__tile_info">
        <div className="combo__tile_texts">
          <p>{part?.partDetails.primaryPart.wheelPartNumber}</p>
          <p className="combo__tile_sub">
            {part?.partDetails.primaryPart.wheelDiameter}&quot;
          </p>
          <p className="combo__tile_price">
            <PartPrice part={part} quantity={quantity} />
          </p>
        </div>
        <div>
          <Image
            alt="product image"
            className="combo__tile_image"
            errorClassName="opacity-60 blur-[16px]"
            fallbackSrc={getPartFallbackSrc(partTypeWheel)}
            src={fixTireImageUrl(part.partDetails.primaryPart.wheelImageLink)}
          />
        </div>
      </div>
      {shouldRenderStockData && part && (
        <WheelStock
          allStock={allStock!}
          dlrStock={dlrStock}
          dropdownId={`wheel-stock-${part?.partDetails.primaryPart.itemId}`}
          isRestricted={!isLoggedOn && stockIsEnabled}
          part={part}
          rltStock={rltStock}
        />
      )}
    </div>
  );
};
